import axios from 'axios';

const themeApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/webmanager`,
  withCredentials: true,
});

themeApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const xsrfToken = localStorage.getItem('XSRF-TOKEN') || document.cookie.match(/XSRF-TOKEN=([^;]+)/)?.[1];
    if (xsrfToken) {
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken);
    }
    if (config.method === 'post' && config.data) {
      config.headers['Content-Type'] = 'application/json';
    }
    console.log('Theme API Request:', config.method.toUpperCase(), config.url, config.headers, config.data);
    return config;
  },
  (error) => {
    console.error('Theme API Request Error:', error);
    return Promise.reject(error);
  }
);

themeApi.interceptors.response.use(
  (response) => {
    console.log('Theme API Response:', response.status, response.data);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 429 && !originalRequest._retryCount) {
      originalRequest._retryCount = 0;
    }
    const maxRetries = 3;
    const retryDelay = (attempt) => Math.pow(2, attempt) * 1000;
    if (error.response?.status === 429 && originalRequest._retryCount < maxRetries) {
      originalRequest._retryCount += 1;
      const delay = retryDelay(originalRequest._retryCount);
      console.warn(`429 Too Many Requests, retrying (${originalRequest._retryCount}/${maxRetries}) after ${delay}ms`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      return themeApi(originalRequest);
    }
    console.error('Theme API Response Error:', error.response?.status, error.response?.data);
    return Promise.reject(error);
  }
);

export const getTheme = () => themeApi.get('/theme');
export const updateTheme = (data) => themeApi.post('/theme', data);
